// Cognito Groups — a user can belong to multiple (e.g. Advisor + Admin)
// Note: "Owner" is property-scoped (derived from UserProperty.isOwned), not a platform role
export enum CognitoGroup {
  SuperAdmin = 'SuperAdmin',
  Admin = 'Admin',
  Advisor = 'Advisor',
  Buyer = 'Buyer',
}

export interface User {
  id: string;
  name?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  isProviderUser?: boolean;
  isProfileComplete: boolean;
  roles: CognitoGroup[];
}

export enum UserAttribute {
  name = 'name',
  givenName = 'given_name',
  familyName = 'family_name',
  isProfileComplete = 'custom:isProfileComplete',
}
